import Legend from "./Legend"
import Vue from "vue"

export default class LegendControl {
  constructor() {
    // eh
  }
  onAdd(map) {
    let clazz = Vue.extend(Legend)
    this.el = document.createElement("div")
    this.el.classList.add("mapboxgl-ctrl")
    let container = this.el.appendChild(document.createElement("div"))
    this.vue = new clazz().$mount(container)
    this.vue.map = map
    return this.el
  }
  onRemove(map) {
    this.vue.$destroy()
  }
  getDefaultPosition() {
    return "bottom-left"
  }
}


// WEBPACK FOOTER //
// ./src/components/LegendControl.js